/** Hook for consuming the TierContext. */
// @ts-check
import { useContext } from 'react';
import { TierContext } from '@/features/tier/TierContext.def';

/**
 * @returns {import('@/features/tier/TierContext.def').TierContextValue}
 */
export const useTier = () => {
  const context = useContext(TierContext);
  if (!context) {
    throw new Error('useTier must be used within a TierProvider');
  }
  return context;
};
